import cn from 'classnames';
import { ComponentProps, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

// to be deprecated

interface Props extends ComponentProps<'input'> {
    name: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const RHFInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { getFieldState, formState } = useFormContext();
    const fieldState = getFieldState(props.name, formState);

    return (
        <div className="w-full">
            {props.label ? (
                <label className="flex justify-between relative text-sm w-fit font-medium text-brand-text">
                    <div
                        className={cn('mb-1', {
                            // 'pl-3': props.required
                        })}>
                        {props.label}
                        {props.required && (
                            <sup className="absolute -top-1 -right-2.5 text-lg text-brand-red-light">*</sup>
                        )}
                    </div>
                </label>
            ) : null}
            <input
                {...props}
                ref={ref}
                autoComplete="off"
                className={cn(
                    'appearance-none block w-full px-3 py-2 text-sm bg-brand-background-dark border border-brand-neutral-700 rounded-md text-brand-neutral-400 placeholder-brand-neutral-600 focus:outline-none focus:ring-brand-primary focus:border-brand-primary',
                    { ['cursor-not-allowed']: props.disabled },
                    props.className
                )}
            />
            {fieldState.error && (fieldState.isTouched || formState.isSubmitted) ? (
                <span className="text-brand-red text-xs italic">{fieldState.error?.message}</span>
            ) : null}
        </div>
    );
});

RHFInput.displayName = 'RHFInput';

export default RHFInput;
